import styled from "styled-components";
import { color } from "../../shared/styles";
import { StyledTableCell } from "../../shared/components/CustomTable/Styled";

export const ExportBar = styled.div`
    display: flex;
    justify-content: flex-end;
    gap: 8px;
    margin-bottom: 8px;
`;

export const QuickFiltersBar = styled.div`
    display: flex;
    gap: 8px;
    margin-bottom: 8px;
    flex-wrap: wrap;
`;

export const SectionCard = styled.div`
    border: 1px solid ${color.secondary.GREY_4};
    border-radius: 6px;
    background: ${color.emphasis.NEUTRAL_N0};
    padding: 8px;
    margin-bottom: 8px;
`;

export const SectionHeader = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 6px;
`;

export const SectionTitle = styled.div`
    font-size: 12px;
    font-weight: 600;
    color: ${color.secondary.CHARCOAL};
`;

export const SectionBody = styled.div`
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
`;

export const SectionButton = styled.button`
    height: 30px;
    padding: 0 10px;
    border-radius: 5px;
    border: 1px solid ${color.secondary.GREY_4};
    background: ${color.emphasis.NEUTRAL_N5};
    color: ${color.secondary.CHARCOAL};
    cursor: pointer;

    &:hover {
        border-color: ${color.primary.BLUE_B100};
        color: ${color.primary.BLUE_B100};
    }
`;

export const SectionButtonPrimary = styled(SectionButton)`
    background: ${color.primary.BLUE_B100};
    color: ${color.emphasis.NEUTRAL_N0};
    border-color: ${color.primary.BLUE_B100};

    &:hover {
        background: ${color.primary.BLUE_B200};
        border-color: ${color.primary.BLUE_B200};
        color: ${color.emphasis.NEUTRAL_N0};
    }
`;

export const SectionButtonGhost = styled(SectionButton)`
    background: transparent;
`;

export const GuideGrid = styled.div`
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 8px;
    margin-top: 8px;
`;

export const GuideBlock = styled.div`
    border: 1px solid ${color.secondary.GREY_4};
    border-radius: 6px;
    background: ${color.emphasis.NEUTRAL_N5};
    padding: 8px;
`;

export const GuideTitle = styled.div`
    font-size: 12px;
    font-weight: 600;
    margin-bottom: 6px;
    color: ${color.secondary.CHARCOAL};
`;

export const GuideList = styled.ul`
    margin: 0;
    padding-left: 16px;
    font-size: 12px;
`;

export const InlineCode = styled.code`
    background: ${color.secondary.LIGHT_GREY};
    padding: 0 4px;
    border-radius: 4px;
`;

export const ExpandCell = styled(StyledTableCell)`
    cursor: pointer;
    width: 36px;
    color: ${color.secondary.CHARCOAL};
`;

export const DetailsCell = styled(StyledTableCell)`
    background: ${color.emphasis.NEUTRAL_N5};
    padding-top: 4px;
    padding-bottom: 4px;
    border-top: 2px solid ${color.secondary.GREY_4};
`;

export const DetailsWrapper = styled.div`
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 8px;
    border: 1px solid ${color.secondary.GREY_4};
    border-radius: 6px;
    padding: 8px;
    background: ${color.emphasis.NEUTRAL_N0};
    margin-bottom: 8px;
`;

export const Label = styled.div`
    font-size: 11px;
    color: ${color.secondary.CHARCOAL};
    opacity: 0.8;
`;

export const Value = styled.div`
    font-size: 12px;
    color: ${color.secondary.CHARCOAL};
    word-break: break-word;
`;

export const JsonBox = styled.pre<{ borderLeftColor?: string }>`
    margin: 0;
    padding: 6px;
    background: ${color.secondary.LIGHT_GREY};
    border: 1px solid ${color.secondary.GREY_4};
    border-left: 4px solid
        ${(p) => p.borderLeftColor || color.secondary.GREY_4};
    border-radius: 6px;
    max-height: 240px;
    overflow: auto;
    font-size: 11px;
    line-height: 1.2;
`;


